<!-- @format -->

@if ((shipMode$ | async) === 'shipToMe' && shipToMeButtonText$ | async; as shipToMeButtonText) {
	<div id="pdp-ship-to-me-subtext">
		@if (shipToMeButtonText.fulfillmentLabelTextLine1) {
			<div
				id="pdp-ship-to-me-line1"
				class="hmf-body-m hmf-body-m-l hmf-mb-xxs"
				[ngClass]="{
					'label-base-subtle': shipToMeButtonText.fulfillmentButtonDisabledClass,
					'label-base': !shipToMeButtonText.fulfillmentButtonDisabledClass
				}">
				{{ shipToMeButtonText.fulfillmentLabelTextLine1 }}
				<pdp-feature-change-zip-code-button
					[isSubtext]="true"
					[isDisabled]="
						shipToMeButtonText.fulfillmentButtonDisabledClass
					"></pdp-feature-change-zip-code-button>
			</div>
		}
		@if (shipToMeButtonText.lowStockMessage) {
			<div
				id="pdp-ship-to-me-low-stock"
				class="hmf-mb-xxs hmf-body-bold-m label-warning">
				{{ shipToMeButtonText.lowStockMessage }}
			</div>
		}

		@if (
			!shipToMeButtonText?.notAvailable && timerRunning && (GTGTHomrScheduleContent$ | async);
			as homrTimerContent
		) {
			<div>
				<span class="hmf-body-s hmf-body-m-m label-base"
					>Get it by Father's Day if ordered within the next 
					<common-timer
						[homrTimerContent]="homrTimerContent"
						(timerRunning)="timerRunning = $event"></common-timer
				></span>
			</div>
		}
	</div>
}
